import { useId } from "react";

export function Checkbox({
  checked = false,
  onChange = () => {},
  required = false,
  label = "",
  hidden = false,
  uncontrolled = false,
}) {
  const id = useId();

  if (hidden) {
    return null;
  }

  if (uncontrolled) {
    return (
      <div className="form-check">
        <input
          id={id}
          type="checkbox"
          className="form-check-input"
          onChange={onChange}
          required={required}
        />

        <label className="form-check-label" htmlFor={id}>
          {label}
        </label>
      </div>
    );
  }

  return (
    <div className="form-check">
      <input
        id={id}
        type="checkbox"
        className="form-check-input"
        checked={checked}
        onChange={onChange}
        required={required}
      />

      <label className="form-check-label" htmlFor={id}>
        {label}
      </label>
    </div>
  );
}
